module.exports = __webpack_public_path__ + "media/images/menu/sextans-1d26f5a80e57a715ce42912ea387937c.jpg";